import { BodyText, Flex, List, ListItem } from '@utilitywarehouse/hearth-react';

import './styles.scss';

type NumberedListProps = {
  items: string[] | { title: string; description: string }[];
};

const NumberedList = ({ items }: NumberedListProps) => {
  return (
    <List paddingNone className="numbered-list">
      {items.map((item, index) => (
        <ListItem key={index}>
          <BodyText
            weight="bold"
            className="numbered-list__item-number"
            aria-hidden
          >
            {index + 1}.
          </BodyText>
          {typeof item === 'string' ? (
            <BodyText>{item}</BodyText>
          ) : (
            <Flex direction="column" marginTop="150">
              <BodyText weight="bold">{item.title}</BodyText>
              {item.description ? (
                <BodyText weight="regular">{item.description}</BodyText>
              ) : null}
            </Flex>
          )}
        </ListItem>
      ))}
    </List>
  );
};

export { NumberedList };
